import React, { Component } from "react";
import { connect } from "react-redux";
import "./App.css";
import Layout from "./components/Shared/Layout";
import Login from "./components/Authentication/login";
import ProtectedRoute from "./components/Authentication/ProtectedRoute";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import socket from "./services/socket";
// import { setEncryptionEnabled } from "./utils/crypto";


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEncryptionEnabled: null,
    };
  }

  // componentDidMount() {
  //   socket.connect();

  //   socket.on("connect", () => {});

  //   socket.on("connect_error", (err) => {});

  //   socket.on("isEncryptionEnabled", (data) => {
  //     this.setState({ isEncryptionEnabled: data });
  //     setEncryptionEnabled(data);
  //   });

  //   socket.on("disconnect", () => {});
  // }

  // componentWillUnmount() {
  //   socket.off("connect");
  //   socket.off("isEncryptionEnabled");
  //   socket.off("disconnect");
  // }

  render() {
    const {
      darkMode,
      boxLayout,
      darkSidebar,
      iconColor,
      gradientColor,
      rtl,
      fontType,
    } = this.props;

    return (
      <div
        className={`${darkMode ? "dark-mode" : ""}${
          darkSidebar ? "sidebar_dark" : ""
        } ${iconColor ? "iconcolor" : ""} ${
          gradientColor ? "gradient" : ""
        } ${rtl ? "rtl" : ""} ${
          fontType ? fontType : ""
        }${boxLayout ? "boxlayout" : ""}`}
      >
        <Router>
          <Routes>

            
            <Route path="/login" element={<Login />} />

            
            

            
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            />

          </Routes>
        </Router>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  darkMode: state.settings.isDarkMode,
  darkSidebar: state.settings.isDarkSidebar,
  iconColor: state.settings.isIconColor,
  gradientColor: state.settings.isGradientColor,
  rtl: state.settings.isRtl,
  fontType: state.settings.isFont,
  boxLayout: state.settings.isBoxLayout,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);